/**
 * What the composer knows at send time: the data sources picked and the open
 * thread.
 */
export type ComposerSendContext = {
  selections: unknown[];
  threadId?: string | null;
};

export type ComposerSendHandler = (
  message: string,
  context: ComposerSendContext
) => boolean | void;

/** True when the registered form draft took the message. */
export const dispatchComposerSend = (
  handler: ComposerSendHandler | null | undefined,
  message: string,
  context?: Partial<ComposerSendContext>
): boolean =>
  handler?.(message, {
    selections: context?.selections ?? [],
    threadId: context?.threadId ?? null,
  }) === true;
